import React from 'react'
import { Link as BreezeLink, LinkProps } from '@skedulo/breeze-ui-react'
import { EventBus } from '../../core/events'
import { useEventBus } from '../../core/hooks'
import { CoreEventType } from '../../core/types'

export interface IEventTargetDetails {
  metaKey?: boolean
  href?: string
  target?: string
}

const navHandler = <Event,>(
  { metaKey, href, target }: IEventTargetDetails,
  clickEvent: React.SyntheticEvent,
  eventbus: EventBus<Event>,
) => {
  if (!href) return
  const url = new URL(href)
  if (
    metaKey ||
    (target && target !== '_self') ||
    url.origin !== window.location.origin ||
    (url.pathname === window.location.pathname &&
      url.search === window.location.search &&
      url.hash !== window.location.hash)
  ) {
    // Let the browser handle it
    return
  }
  clickEvent.stopPropagation()
  clickEvent.preventDefault()
  eventbus.emit({
    topic: 'routing:navigate:v1',
    payload: { url: url.pathname + url.search + url.hash },
  })
}

export const Anchor = ({
  children,
  href,
  ...props
}: JSX.IntrinsicElements['a']) => {
  const eventbus = useEventBus<CoreEventType>()
  return (
    <a
      {...props}
      href={href}
      onClick={(event) => {
        const { href, target } = event.currentTarget
        navHandler<CoreEventType>(
          { metaKey: event.metaKey, href, target },
          event,
          eventbus,
        )
      }}
    >
      {children}
    </a>
  )
}

export const Link = (props: LinkProps) => {
  const eventbus = useEventBus<CoreEventType>()
  return (
    <BreezeLink
      {...props}
      onClick={(event) => {
        const { href, target } = event.currentTarget
        // Custom components don't auto build the full link url, so we need to
        // prepend origin if it's not already there
        const { origin } = window.location
        const joinedHref = !href?.includes(origin) ? `${origin}${href}` : href
        navHandler<CoreEventType>(
          { metaKey: event.metaKey, href: joinedHref, target },
          event,
          eventbus,
        )
      }}
    />
  )
}
